import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BasePage } from '@shared-pages/base.page';
import { firstValueFrom } from 'rxjs';
import { PublicReservationProvider } from '@app/modules/public/public-events/providers/api/public-reservation.provider';
import { IPublicReservation } from '@app/modules/public/public-events/models/public-reservation';
import { IFormGroup } from '@shared-libs/interfaces';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import { SharedFormValidators } from '@shared-libs/form-validators';
import { PublicRatingProvider } from '../../provider/api/public-rating.provider';
import { formIsValid } from '@shared-libs/helpers';

@Component({
	selector: 'rating-page',
	templateUrl: 'rating.page.html',
	styleUrls: ['rating.page.scss'],
})
export class RatingPage extends BasePage implements OnInit {
	public reservationExternalId: string;
	public reservation: IPublicReservation;
	public ratingForm: IFormGroup<{ score: number; note: string }>;
	public noReservationFound: boolean;
	public reservationSubmitted: boolean;

	constructor(
		private readonly route: ActivatedRoute,
		private readonly provider: PublicRatingProvider,
		private readonly reservationProvider: PublicReservationProvider
	) {
		super();
	}

	public async ngOnInit(): Promise<void> {
		this.reservationExternalId = (await firstValueFrom(this.route.params))?.reservationExternalId;
		const initialRating = this.formatInitialRating((await firstValueFrom(this.route.queryParams))?.rating);

		if (this.reservationExternalId) {
			this.reservation = await this.reservationProvider.getOneByExternalId(this.reservationExternalId);

			if (!this.reservation) {
				this.noReservationFound = true;
			}

			if (initialRating) {
				try {
					await this.provider.createRatingForScore(this.reservationExternalId, { score: initialRating });
				} catch (err) {}
			}

			this.initializeForm(initialRating);
		} else {
			this.noReservationFound = true;
		}
	}

	public async submitRating(): Promise<void> {
		if (formIsValid(this.ratingForm)) {
			await this.provider.createOrUpdateRating(this.reservationExternalId, this.ratingForm.value);
			this.reservationSubmitted = true;
		}
	}

	private initializeForm(score: number): void {
		this.ratingForm = new UntypedFormGroup({
			score: new FormControl<number>(score, [SharedFormValidators.required, SharedFormValidators.number(1, 5)]),
			note: new FormControl<string>(null),
		});
	}

	private formatInitialRating(score: string): number {
		if (['1', '2', '3', '4', '5'].includes(score)) {
			return parseInt(score);
		}
		return null;
	}
}
